import apiFetch from '../apiFetch'

export default function (token, organizedUnits) {
  return apiFetch({ endPoint: 'commissionCancellation/GetListForModal', method: 'POST', body: organizedUnits, token: token })
}
